
import hbcg from '@/assets/images/hbcg.png'
import zfcg from '@/assets/images/zfcg.png'
import jdcg from '@/assets/images/jdcg.png'
import hgtbfw from '@/assets/images/hgtbfw.png'
import qhggzy from '@/assets/images/qhggzy.png'
import hbggzy from '@/assets/images/hbggzy.png'
import qhxzsp from '@/assets/images/qhxzsp.png'
import hbggzyjy from '@/assets/images/hbggzyjy.png'
import hbzffwgl from '@/assets/images/hbzffwgl.png'
import jzbqlcdzjypt from '@/assets/images/jzbqlcdzjypt.png'
import lbqp from '@/assets/images/lbqp.png'
import hzb from '@/assets/images/hzb.png'
import zcjbhbzq from '@/assets/images/zcjbhbzq.png'
import zbt from '@/assets/images/zbt.png'

export  default {
    hbcg,
    zfcg,
    jdcg,
    hgtbfw,
    qhggzy,
    hbggzy,
    qhxzsp,
    hbggzyjy,
    hbzffwgl,
    jzbqlcdzjypt,
    lbqp,
    hzb,
    zcjbhbzq,
    zbt,
}